import { render, staticRenderFns } from "./CrowdReportScreen.vue?vue&type=template&id=3a51d1ce"
import script from "./CrowdReportScreen.vue?vue&type=script&lang=js"
export * from "./CrowdReportScreen.vue?vue&type=script&lang=js"
import style0 from "./CrowdReportScreen.vue?vue&type=style&index=0&id=3a51d1ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports